<section class="module-notices animated fadeIn">
    <!--<div class="_col" cg-busy="$ctrl.promiseNotices">-->
    <div class="_col">
        <div class="fx-column animated fadeInLeft" *ngIf="action === 'playlist'">
        <!--<div class="fx-column animated fadeInLeft" *ngIf="true">-->
            <div class="_module-header-block">
                <h3 class="clearfix">
                    Playlists
                    <a ui-sref="main.notice_create"
                       class="btn-add pull-right"
                       uib-tooltip="Create Notice"
                       tooltip-placement="bottom"
                       tooltip-trigger="hover"
                       (click)="noticesService.isNoticeWizardShow = true;">
                        <i class="fa fa-plus-circle fa-2x"></i>
                    </a>
                </h3>
                <div class="module-search">
                    <div class="input-group">
                        <input class="form-control" [ngModel]="search.playlist" placeholder="Search Playlists">
                        <div class="input-group-btn">
                            <button type="button" class="btn btn-default" aria-label="Search">
                                <span class="glyphicon glyphicon-search"></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="_items-templates" ss-container>
                <ul class="list-unstyled" >
                    <!--<li *ngFor="item in listPlaylist | filter : search.playlist" let-index="index">-->
                    <li *ngFor="let item of noticesService.data.allNotices.data.playlists">
                        <a href="" (click)="showNoticesByPlaylist(item)" class="_item">
                            <span [innerHtml]="item.title"></span>
                            <span class="_info">
                                <span class="i-count" [innerHtml]="item.announcements"></span>
                                <i class="fa fa-arrow-right i-arrow"></i>
                            </span>
                        </a>
                    </li>
                    <li>
                        <a (click)="showNoticesByPlaylist(item)" class="_item">
                            <span>Title</span>
                            <span class="_info">
                                <span class="i-count">Announcement</span>
                                <i class="fa fa-arrow-right i-arrow"></i>
                            </span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="fx-column animated fadeInLeft" *ngIf="action === 'notices'">
            <div class="_module-header-block">
                <h3 class="clearfix">
                    <a (click)="action = 'playlist'" class="module-title"><i class="fa fa-arrow-left"></i> {{currentPlaylist.title}}</a>
                    <a ui-sref="main.notice_create"
                       class="btn-add pull-right"
                       uib-tooltip="Create Notice"
                       tooltip-placement="bottom"
                       tooltip-trigger="hover"
                       (click)="noticesService.isNoticeWizardShow = true;">
                        <i class="fa fa-plus-circle fa-2x"></i>
                    </a>
                </h3>
                <div class="module-search">
                    <div class="input-group">
                        <input class="form-control" [ngModel]="search.notice" placeholder="Search Notices">
                        <div class="input-group-btn">
                            <button type="button" class="btn btn-default" aria-label="Search">
                                <i class="fa fa-search"></i>
                            </button>
                            <button uib-tooltip="Filter Notices"
                                    tooltip-placement="bottom"
                                    type="button"
                                    class="btn btn-default btn-show-filter" [ngClass]="{'active': showFilter}" aria-label="Filter" (click)="showFilter = !showFilter">
                                <i class="fa fa-filter"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="module-notice-filter">
                    <div class="filter-form" *ngIf="showFilter">
                        <div class="filter-status">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="checkbox">
                                        <label>
                                            <input type="checkbox" [ngModel]="filtered.status.active">
                                            <span class="status"><i class="_active"></i> Active</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="checkbox">
                                        <label>
                                            <input type="checkbox" [ngModel]="filtered.status.expired">
                                            <span class="status"><i class="_expired"></i> Expired</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="checkbox">
                                        <label>
                                            <input type="checkbox" [ngModel]="filtered.status.future">
                                            <span class="status"><i class="_future"></i> Future</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="checkbox">
                                        <label>
                                            <input type="checkbox" [ngModel]="filtered.status.archived">
                                            <span class="status"><i class="_archived"></i> Archived</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="filter-categories" uib-dropdown>
                            <span class="cat-label" uib-dropdown-toggle>
                                Select Categories
                                <span class="caret pull-right m-t-sm"></span>
                            </span>
                            <div uib-dropdown-menu>
                                <ul ss-container role="menu" style="height: 60px;overflow: auto">
                                    <li *ngFor="let category of categoriesList">
                                        <div class="checkbox">
                                            <label>
                                                <input type="checkbox" [ngModel]="filtered.category[category.id]">
                                                <span [innerHtml]="category.title"></span>
                                            </label>
                                        </div>
                                    </li>
                                </ul>

                            </div>
                        </div>
                        <script>
                            $(document).on('click', '.dropdown-menu', function (e) {
                                e.stopPropagation();
                            });
                        </script>
                    </div>
                    <div class="filter-labels" *ngIf="!showFilter">
                        <!--<span *ngFor="let v of filtered.status">-->
                            <!--<span *ngIf="v">{{v}}</span>-->
                            <!--<a href="" (click)="filtered.status[v]=false"></a>-->
                        <!--</span>-->
                        <span *ngFor="let v of filtered.category">
                            <span *ngIf="v">{{getCategoryNameById(v)}}</span>
                            <a href="" (click)="filtered.category[v]=false"></a>
                        </span>
                    </div>
                </div>
            </div>
            <div class="_items-templates" ss-container>
                <div >
                    <ul class="list-unstyled status" >
                        <!--<li class="droupdown " [ngClass]="'_' + item.status"  uib-dropdown *ngFor="item in listNotices-->
                        <!--| orderBy: 'id' : 1-->
                        <!--| filter : search.notice-->
                        <!--| noticesFilter: filtered-->
                        <!--track by $index">-->
                        <li class="droupdown " [ngClass]="'_' + item.status"  uib-dropdown
                            *ngFor="let item of noticesService.data.allNotices.data.notices; trackBy: index;">
                            <div class="_item" [ngClass]="{'active': noticesService.currentNotice.id == item.id}" (click)="setCurrentNotice(item)" >
                                <span [innerHtml]="item.title || 'empty'"></span>
                            </div>
                            <a class="_info dropdown-toggle" href="" id="droupdown_{{index}}" data-toggle="dropdown"><i class="glyphicon glyphicon-option-vertical i-copy"></i></a>
                            <ul role="menu" class="dropdown-menu pull-right">
                                <li><a ui-sref="main.notice_edit({step: 'message', noticeId: item.id})"><i class="fa fa-pencil"></i> Edit</a></li>
                                <li *ngIf="item.status != 'archived'"><a href="" (click)="deleteItem(item)"><i class="fa fa-archive"></i> Archive</a></li>
                                <li *ngIf="item.status == 'archived'"><a href="" (click)="restoreItem(item)"><i class="fa fa-archive"></i> Restore</a></li>
                                <li><a ui-sref="main.notice_create({step: 'message', type: 'copy', noticeId: item.id})"><i class="fa fa-copy"></i> Create copy</a></li>
                            </ul>
                        </li>
                        <li class="droupdown ">
                            <div class="_item" (click)="setCurrentNotice(item)" >
                                <span>Title</span>
                            </div>
                            <a class="_info dropdown-toggle" id="droupdown_1" data-toggle="dropdown"><i class="glyphicon glyphicon-option-vertical i-copy"></i></a>
                            <ul role="menu" class="dropdown-menu pull-right">
                                <li><a><i class="fa fa-pencil"></i> Edit</a></li>
                                <li><a (click)="deleteItem(item)"><i class="fa fa-archive"></i> Archive</a></li>
                                <li><a (click)="restoreItem(item)"><i class="fa fa-archive"></i> Restore</a></li>
                                <li><a><i class="fa fa-copy"></i> Create copy</a></li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="_main-col">

        <!--<display template="template" building="buildingName"></display>-->
        <section class="module-display">
            <div class="_header">
                <div class="row">
                    <div class="col-sm-6">
                        <div class="display-orientation btn-group" >
                            <!--<a ui-sref="main.all_notices" class="btn active" tooltip-append-to-body="true" uib-tooltip="List" tooltip-placement="bottom">
                                <i style="position: relative; top: 1px;"  class="glyphicon glyphicon-menu-hamburger"></i>
                            </a>
                            <a ui-sref="main.calendar" class="btn" tooltip-append-to-body="true"  uib-tooltip="Calendar" tooltip-placement="bottom">
                                <i class="fa fa-calendar"></i>
                            </a>
                            -->
                        </div>
                    </div>
                    <div class="col-sm-6 text-right">
                        <div class="display-orientation btn-group"  data-toggle="buttons">
                            <label class="btn" tooltip-append-to-body="true" uib-tooltip="Landscape" tooltip-placement="bottom"
                                   [ngClass]="{'active': orientation == 'horizontal'}" (click)="orientation='horizontal';scalingScreen('', '');">
                                <input type="radio" value="horizontal" checked>
                                <i class="fa fa-television"></i>
                            </label>
                            <label class="btn" tooltip-append-to-body="true" uib-tooltip="Portrait" tooltip-placement="bottom"
                                   [ngClass]="{'active': orientation == 'vertical'}" (click)="orientation='vertical';scalingScreen('', '');">
                                <input type="radio" value="vertical">
                                <i class="fa fa-tablet"></i>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div id="display" #display [ngClass]="newTheme ? 'is_new_theme'  : 'is_pc'">
                <div class="display-screen" id="displayScreen" #displayScreen [ngClass]="orientation">
                    <div class="display-wrap">
                        <!--<div class="_frame" cg-busy="$ctrl.promiseContent" >-->
                        <div class="_frame">
                            <div class="_wrap">
                                <div id="screen_content" ss-container="" [innerHtml]="contentHtml"></div>
                            </div>
                        </div>
                        <div class="display-header">
                            <div class="_time">
                                <span class="icon-clock"></span>
                                <span class="clock-val" [innerHtml]="currentDate | date : 'h:mm a'"></span>
                            </div>
                            <div class="_weather-now">
                        <span class="icon-weather">
                            <img *ngIf="currentWeather.icon" [src]="'/assets/img/weather_icons/' + currentWeather.icon">
                        </span>
                                <span class="weather-temp"><span [innerHtml]="currentWeather.temp || 'N/A'"></span>° C</span>
                            </div>
                            <div class="_date">
                                <span class="icon-calendar"></span>
                                <span class="date-val">
                            <span class="date-name" [innerHtml]="currentDate | date : 'EEE,'"></span>
                            <span class="date-month" [innerHtml]="currentDate | date : 'MMMM d'"></span>
                            <span class="date-month-short" [innerHtml]="currentDate | date : 'd MMM'"></span>
                        </span>
                            </div>
                        </div>
                        <!--<div class="display-image-container" *ngIf="$root.currentUser.logo" style="background-image: url({{$root.currentUser.logo}});"></div>-->
                        <div class="display-footer">
                            <div class="_buttons">
                                <div class="_button">
                                    <span class="_sport"></span>
                                    Sports
                                </div>
                                <div class="_button">
                                    <span class="_news"></span>
                                    News
                                </div>
                                <div class="_button">
                                    <span class="_weather"></span>
                                    Weather
                                </div>
                                <div class="_button active">
                                    <span class="_notice"></span>
                                    Notices
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </section>
    </div>
</section>



// WEBPACK FOOTER //
// /app/src/app/views/notices/playlist-and-notices-list/playlist-and-notices-list.component.html